export default __webpack_public_path__ + "static/media/SconeProductInfo2.483dd9e4.png";